import React from "react";
import {
  Card,
  CardHeader,
  CardFooter,
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label
} from "reactstrap";
import CategoriesCollapse from "../categories/CategoriesCollapse";
import UsersDropdown from "../users/UsersDropdown";
import Moment from "react-moment";
import DeletePostModal from "./DeletePostModal";

export default class PostList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterModalOpen: false,
      tempSearch: "",
      tempCategoryIds: [],
      tempUserId: null
    };
    this.toggleFilterModal = this.toggleFilterModal.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleCategoryChange = this.handleCategoryChange.bind(this);
    this.handleUserChange = this.handleUserChange.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.onUserSelectInputChange = this.onUserSelectInputChange.bind(this);
  }

  toggleFilterModal() {
    this.setState(prevState => ({
      filterModalOpen: !prevState.filterModalOpen,
      // Reset temp values to current props when opening
      tempSearch: this.props.search || "",
      tempCategoryIds: this.props.category_ids || [],
      tempUserId: this.props.user_id || null
    }));
  }

  handleSearchChange(e) {
    this.setState({ tempSearch: e.target.value });
  }

  handleCategoryChange(category_ids) {
    this.setState({ tempCategoryIds: category_ids });
  }

  handleUserChange(user) {
    this.setState({ tempUserId: user ? user.value : null });
  }

  applyFilters() {
    // Apply all filters at once with a single API call
    if (this.props.applyAllFilters) {
      this.props.applyAllFilters({
        search: this.state.tempSearch,
        category_ids: this.state.tempCategoryIds,
        user_id: this.state.tempUserId
      });
    } else {
      // Fallback to individual calls if applyAllFilters is not available
      this.props.onSearchChange(this.state.tempSearch);
      this.props.onCategoryIdsChange(this.state.tempCategoryIds);
      if (this.state.tempUserId) {
        this.props.onUserChange(this.state.tempUserId);
      } else {
        this.props.onUserChange(null);
      }
    }
    // Close modal
    this.toggleFilterModal();
  }

  clearFilters() {
    // Clear all filters with a single API call
    this.setState({
      tempSearch: "",
      tempCategoryIds: [],
      tempUserId: null
    });
    if (this.props.applyAllFilters) {
      this.props.applyAllFilters({
        search: "",
        category_ids: [],
        user_id: null
      });
    } else {
      // Fallback to individual calls
      this.props.onSearchChange("");
      this.props.onCategoryIdsChange([]);
      this.props.onUserChange(null);
    }
    this.toggleFilterModal();
  }

  onUserSelectInputChange(value) {
    this.props.getUsers({ page: 1, name: value });
  }

  renderFilterModal() {
    const { categories } = this.props.categoryReducer;
    const { profile } = this.props.authReducer;
    const { userOptions } = this.props.userReducer;
    
    const closeBtn = (
      <button className="close" onClick={this.toggleFilterModal}>
        <i className="fa fa-times" /> 关闭
      </button>
    );

    return (
      <Modal
        isOpen={this.state.filterModalOpen}
        toggle={this.toggleFilterModal}
        centered={true}
        contentClassName="bg-lightest"
        size="md"
      >
        <ModalHeader close={closeBtn}>筛选文章</ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label>分类</Label>
              {categories ? (
                <CategoriesCollapse
                  categories={categories}
                  category_ids={this.state.tempCategoryIds}
                  onCategoryIdsChange={this.handleCategoryChange}
                />
              ) : null}
            </FormGroup>
            
            {profile && profile.role_id === 1 && userOptions ? (
              <FormGroup>
                <Label>编辑</Label>
                <UsersDropdown
                  userOptions={userOptions}
                  onSelectChange={this.handleUserChange}
                  onInputChange={this.onUserSelectInputChange}
                />
              </FormGroup>
            ) : null}
            
            <FormGroup>
              <Label>搜索</Label>
              <Input
                type="text"
                placeholder="搜索"
                value={this.state.tempSearch}
                onChange={this.handleSearchChange}
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.applyFilters}>
            搜索
          </Button>
          <Button color="secondary" onClick={this.clearFilters}>
            清除
          </Button>
          <Button color="white" onClick={this.toggleFilterModal}>
            取消
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  render() {
    const { category_ids, search } = this.props;
    const { posts, loading } = this.props.postReducer;

    const paginationDiv = posts ? (
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <span className="text-muted">
            第 {posts.current_page} 页
          </span>
        </div>
        <div>
          <Button
            color="primary"
            size="sm"
            disabled={!posts.prev_page_url}
            onClick={() => this.props.goToPage(posts.current_page - 1)}
            className="mr-2"
          >
            上一页
          </Button>
          <Button
            color="primary"
            size="sm"
            disabled={!posts.next_page_url}
            onClick={() => this.props.goToPage(posts.current_page + 1)}
          >
            下一页
          </Button>
        </div>
      </div>
    ) : null;

    return (
      <div className="container-fluid mt-2">
        <DeletePostModal {...this.props} />
        {this.renderFilterModal()}
        <Card className="shadow border-0 border-l main-card">
          <CardHeader className="border-0 border-top-l">
            <div className="d-flex justify-content-end align-items-center">
              <div className="mr-2">
                <Button color="secondary" onClick={this.toggleFilterModal}>
                  <i className="fas fa-filter mr-2" />
                  筛选
                </Button>
                {(search || (category_ids && category_ids.length > 0)) && (
                  <span className="ml-3 text-muted">
                    {search && <span>搜索: {search}</span>}
                    {category_ids && category_ids.length > 0 && (
                      <span className="ml-2">分类: {category_ids.length}</span>
                    )}
                  </span>
                )}
              </div>
              <Button color="primary" onClick={this.props.createPost}>
                写文章
              </Button>
            </div>
          </CardHeader>
          <div className="table-responsive" style={{ position: 'relative' }}>
            {loading && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(255, 255, 255, 0.8)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 10
                }}
              >
                <div className="text-center">
                  <i className="fas fa-spinner fa-spin fa-3x text-primary"></i>
                </div>
              </div>
            )}
            <table className="table align-items-center">
              <thead className="thead-light">
                <tr>
                  <th>状态</th>
                  <th>标题</th>
                  <th>编辑</th>
                  <th>发布时间</th>
                  <th className="text-right"></th>
                </tr>
              </thead>
              <tbody>
                {posts.data
                  ? posts.data.map(post => (
                      <tr key={`posts-${post.id}`}>
                        <td>
                          <span className="badge badge-dot mr-4">
                            <i
                              className={
                                post.active ? "bg-success" : "bg-warning"
                              }
                            />
                            <span className="status">
                              {post.active ? "发布" : "草稿"}
                            </span>
                          </span>
                        </td>
                        <td className="max-300-text">{post.title}</td>
                        <td>{post.editor.name}</td>
                        <td className="max-100-text">
                          {post.posted_at ? (
                            <Moment
                              parse="YYYY-MM-DD HH:mm:ss"
                              format="MM/DD/YYYY"
                            >
                              {post.posted_at}
                            </Moment>
                          ) : null}
                        </td>
                        <td className="text-right">
                          <UncontrolledDropdown>
                            <DropdownToggle
                              className="btn-icon-only text-light"
                              size="sm"
                              color="link"
                              data-toggle="dropdown"
                              type="button"
                            >
                              <i className="fas fa-ellipsis-v" />
                            </DropdownToggle>
                            <DropdownMenu
                              aria-labelledby="dropdownMenuLink"
                              right
                            >
                              <DropdownItem
                                type="button"
                                onClick={() => this.props.goToPost(post.id)}
                              >
                                修改
                              </DropdownItem>
                              <DropdownItem
                                type="button"
                                onClick={() =>
                                  this.props.toggleDeletePostModal(post)
                                }
                              >
                                删除
                              </DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </td>
                      </tr>
                    ))
                  : null}
              </tbody>
            </table>
          </div>
          <CardFooter className="border-bottom-l">{paginationDiv}</CardFooter>
        </Card>
      </div>
    );
  }
}
